module.exports = __webpack_public_path__ + "src/assets/img/girl_right.dad8ce4f.png";